// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8c559af6","952":"c83a0d19"}[chunkId] + ".chunk.js";
};